module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.1ba21d98.ttf";